<template>
    <div class="container nopadding">
        <div class="wrapper">
            <div class="header"><h1>{{$t('ordine_dettaglio')}}</h1></div>

            <div class="content-full">
                <div v-if="this.order">
                    <div class="ordine">
                        {{$t('ordine_numero')}}: {{this.order.id}} -
                        <inc-order-status :status="this.order.status"/>
                    </div>

                    <inc-order-content :order="this.order"/>

                    <p class="text-center">
                        <span class="text-uppercase">{{$t('attenzione_label')}}</span>:
                        <br>
                        {{$t('ordine_annulla_msg')}}
                    </p>
                    <hr>
                    <div class="container">
                        <div class="row row-sezione">
                            <div class="col-12 text-center">
                                <router-link :to="{name:'orders.history'}">
                                    <button type="button" class="btn btn-default">{{$t('ordine_torna_storico')}}
                                    </button>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex';
    import {getOrder} from '../../api/account';

    import IncOrderStatus from './partials/IncOrderStatus';
    import IncOrderContent from "./partials/IncOrderContent";

    export default {
        name: "Details",
        components: {IncOrderContent, IncOrderStatus},
        data() {
            return {
                order: null
            }
        },
        created() {
            this.fetch();
        },
        computed: {
            ...mapState('localization', {
                language: state => state.language
            }),
            ...mapState('restaurant', {
                id_ristorante: state => state.id,
                locale: state => state.locale
            }),
            ...mapState('auth', {
                user: state => state
            })
        },
        methods: {
            fetch: function () {
                this.showLoading(true);
                getOrder(this.language, {
                    id_ristorante: this.id_ristorante,
                    id_locale: this.locale.id,
                    api_key: this.user.api_key,
                    id: this.$route.params.id
                }).then((response) => {
                    this.order = response.ordine;
                }).catch(({messages}) => {
                    alert(messages.join('\n'));
                }).finally(() => {
                    this.showLoading(false);
                })
            },
            ...mapActions('global', [
                'showLoading'
            ])
        }
    }
</script>
